export enum CoachSmartSpaceChecklistSteps {
  SMART_SPACE_CHECK = 0,
  ADDITIONAL_STANDARDS = 1,
  SAFETY_STRUCTURE_AREA = 2,
}

export interface Options {
  [key: string]: string[];
}
